import type { ReactNode, TdHTMLAttributes, ThHTMLAttributes } from 'react';
import { cx } from './cx';

/** Wide tables scroll inside their box at phone width instead of the page. `bare` drops the box (inside a Card). */
export function TableBox({ children, minWidth = 640, className, label, bare }: { children: ReactNode; minWidth?: number; className?: string; label?: string; bare?: boolean }) {
  return (
    <div
      className={cx('relative overflow-x-auto', !bare && 'rounded-card border border-line bg-white', className)}
      role={label ? 'region' : undefined}
      aria-label={label}
      tabIndex={label ? 0 : undefined}
    >
      <table className="w-full border-collapse text-sm" style={{ minWidth }}>{children}</table>
    </div>
  );
}

export function Th({ className, ...rest }: ThHTMLAttributes<HTMLTableCellElement>) {
  return <th scope="col" className={cx('px-4 py-3 text-left text-xs font-semibold uppercase tracking-[0.04em] text-muted', className)} {...rest} />;
}
export function Td({ className, ...rest }: TdHTMLAttributes<HTMLTableCellElement>) {
  return <td className={cx('px-4 py-3 align-top', className)} {...rest} />;
}
